export interface Comic {
  id: number;
  title: string;
  category: string;
  status: "连载中" | "已完结";
  rating: number;
  chapters: number;
  likes: number;
  cover: string;
  intro: string;
  tags: string[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "可乐少年",
    category: "热血",
    status: "连载中",
    rating: 9.6,
    chapters: 128,
    likes: 128000,
    cover: "https://readdy.ai/api/search-image?query=A%20determined%20young%20hero%20in%20a%20school%20uniform%20holding%20up%20a%20can%20of%20cola%20with%20sparkling%20energy%20effects%2C%20warm%20orange%20and%20caramel%20red%20tones%2C%20dynamic%20action%20manga%20cover%20art%20with%20bold%20lines%20on%20a%20clean%20cream%20background&width=800&height=600&seq=comic-cola-boy&orientation=landscape",
    intro: "一杯快乐水唤醒隐藏能量，平凡少年开启热血逆袭之路。",
    tags: ["热血", "校园", "战斗"],
  },
  {
    id: 2,
    title: "肥宅大冒险",
    category: "搞笑",
    status: "连载中",
    rating: 9.3,
    chapters: 96,
    likes: 96000,
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20overweight%20cartoon%20gamer%20character%20on%20an%20epic%20adventure%20holding%20chips%20and%20cola%2C%20bright%20warm%20yellow%20and%20caramel%20tones%2C%20comedic%20manga%20cover%20with%20pop%20art%20effects%20on%20clean%20background&width=800&height=600&seq=comic-zhai-adventure&orientation=landscape",
    intro: "追更配零食、快乐水不离手，宅家也能来一场爆笑大冒险。",
    tags: ["搞笑", "冒险", "美食"],
  },
  {
    id: 3,
    title: "快乐水日常",
    category: "日常",
    status: "已完结",
    rating: 9.1,
    chapters: 64,
    likes: 74000,
    cover: "https://readdy.ai/api/search-image?query=A%20cozy%20everyday%20life%20manga%20scene%20with%20a%20young%20person%20enjoying%20a%20cola%20and%20snacks%20on%20a%20couch%20at%20home%2C%20soft%20warm%20cream%20and%20tan%20tones%2C%20relaxed%20slice%20of%20life%20cartoon%20illustration&width=800&height=600&seq=comic-cola-daily&orientation=landscape",
    intro: "没有惊天动地，只有快乐水配漫画的平凡又温暖的每一天。",
    tags: ["日常", "治愈", "放松"],
  },
  {
    id: 4,
    title: "深夜可乐站",
    category: "悬疑",
    status: "连载中",
    rating: 9.4,
    chapters: 58,
    likes: 82000,
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20night%20scene%20at%20a%20cola%20vending%20station%20with%20a%20detective%20character%2C%20moody%20warm%20dark%20caramel%20shadows%2C%20suspenseful%20suspense%20manga%20cover%20art%20with%20dramatic%20lighting&width=800&height=600&seq=comic-midnight-cola&orientation=landscape",
    intro: "每晚零点，这家卖快乐水的站台都会迎来一位神秘客人。",
    tags: ["悬疑", "推理", "都市"],
  },
  {
    id: 5,
    title: "元气苏打",
    category: "治愈",
    status: "连载中",
    rating: 9.5,
    chapters: 45,
    likes: 110000,
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20healing%20manga%20cover%20with%20a%20cheerful%20girl%20enjoying%20a%20bubbly%20soda%20drink%20under%20soft%20warm%20sunlight%2C%20gentle%20cream%20and%20caramel%20pastel%20tones%2C%20tender%20and%20uplifting%20cartoon%20illustration&width=800&height=600&seq=comic-soda-power&orientation=landscape",
    intro: "每次喝完快乐水都元气满满，把烦恼都泡进气泡里冲走。",
    tags: ["治愈", "日常", "少女"],
  },
  {
    id: 6,
    title: "气泡异世界",
    category: "奇幻",
    status: "连载中",
    rating: 9.2,
    chapters: 110,
    likes: 89000,
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20of%20a%20colorful%20bubble%20parallel%20world%20with%20floating%20cola%20islands%2C%20warm%20orange%20gold%20and%20caramel%20tones%2C%20whimsical%20and%20vibrant%20cartoon%20illustration%20on%20clean%20background&width=800&height=600&seq=comic-bubble-world&orientation=landscape",
    intro: "一罐快乐水打开通往气泡异世界的大门，冒险就此展开。",
    tags: ["奇幻", "异世界", "冒险"],
  },
  {
    id: 7,
    title: "汽水青春",
    category: "校园",
    status: "已完结",
    rating: 9.0,
    chapters: 52,
    likes: 68000,
    cover: "https://readdy.ai/api/search-image?query=A%20bright%20campus%20manga%20cover%20with%20two%20happy%20students%20sharing%20a%20cola%20on%20a%20school%20rooftop%20at%20sunset%2C%20warm%20cream%20and%20caramel%20tones%2C%20youthful%20and%20nostalgic%20cartoon%20illustration&width=800&height=600&seq=comic-soda-youth&orientation=landscape",
    intro: "青春就是阳光、操场，以及和你分着喝的那瓶快乐水。",
    tags: ["校园", "青春", "恋爱"],
  },
  {
    id: 8,
    title: "冰可乐星球",
    category: "科幻",
    status: "连载中",
    rating: 9.1,
    chapters: 77,
    likes: 70000,
    cover: "https://readdy.ai/api/search-image?query=A%20sci%20fi%20manga%20cover%20of%20an%20alien%20planet%20made%20of%20ice%20and%20cola%20crystals%20with%20a%20young%20astronaut%2C%20warm%20orange%20and%20cool%20caramel%20tones%2C%20futuristic%20and%20stylish%20cartoon%20illustration&width=800&height=600&seq=comic-ice-cola-planet&orientation=landscape",
    intro: "在冰封的快乐水星球上，一场关于拯救与冒险的故事正在上演。",
    tags: ["科幻", "太空", "冒险"],
  },
];